import {
  TROUBLESHOOT_STAT_ERROR,
  TROUBLESHOOT_STAT_KEYS,
  TROUBLESHOOT_STAT_SUCCESS,
  TROUBLESHOOT_STATS_REQUEST,
} from "./ActionType";

const emptyStat = (status = "idle") => ({
  status,
  data: null,
  error: null,
});

const initialState = {
  shopId: null,
  requestId: null,
  isRequest: false,
  isSuccess: false,
  isError: false,
  totalOrders: emptyStat(),
  awaitingOrders: emptyStat(),
  totalSyncOrders: emptyStat(),
};

const statKeys = Object.values(TROUBLESHOOT_STAT_KEYS);

const matchesActiveRequest = (state, action) =>
  state.shopId === action.meta?.shopId &&
  state.requestId === action.meta?.requestId;

const withSummary = (state) => {
  const statuses = statKeys.map((key) => state[key].status);
  return {
    ...state,
    isRequest: statuses.some((status) => status === "loading"),
    isSuccess: statuses.every((status) => status === "success"),
    isError: statuses.some((status) => status === "error"),
  };
};

const statsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TROUBLESHOOT_STATS_REQUEST:
      return {
        ...initialState,
        shopId: action.meta?.shopId ?? null,
        requestId: action.meta?.requestId ?? null,
        isRequest: true,
        totalOrders: emptyStat("loading"),
        awaitingOrders: emptyStat("loading"),
        totalSyncOrders: emptyStat("loading"),
      };

    case TROUBLESHOOT_STAT_SUCCESS: {
      if (!matchesActiveRequest(state, action)) return state;
      const statKey = action.meta?.statKey;
      if (!statKeys.includes(statKey)) return state;

      return withSummary({
        ...state,
        [statKey]: {
          status: "success",
          data: action.payload,
          error: null,
        },
      });
    }

    case TROUBLESHOOT_STAT_ERROR: {
      if (!matchesActiveRequest(state, action)) return state;
      const statKey = action.meta?.statKey;
      if (!statKeys.includes(statKey)) return state;

      return withSummary({
        ...state,
        [statKey]: {
          status: "error",
          data: null,
          error: action.payload || "Stats request is unavailable",
        },
      });
    }

    default:
      return state;
  }
};

export default statsReducer;
